import { getNetworkByUser } from '~/entities/user/user/api/users'
import type { NetworkUser } from '~/entities/user/user/interfaces/user'

import type { SwymService } from '~/interfaces/crud-service'
import type { NetworkResult, SwymResponse } from '~/interfaces/services-dto'

export const NetworkByUserSwymServices: SwymService<NetworkResult<NetworkUser>> = {
  async count() {
    throw new Error('Function not implemented.')
  },
  async getAll(params) {
    // eslint-disable-next-line max-len
    const response: SwymResponse<NetworkResult<NetworkUser>> = await getNetworkByUser(params.hash_key, params.limit, params.page)
      .then((response) => {
        return {
          data: response.result.users.map((el) => {
            const full_name = `${el.first_name} ${el.last_name}`
            const state = Number.parseInt(el.ut_state)
            const external = Number.parseInt(el.tenant_user_status)
            const country = el.country_code
            return ({ ...el, full_name, state, external, country })
          }),
        }
      })
    return response
  },
}
